import React from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import tutorial_step_03 from '../../../../node_modules/itd-common/assets/images/onboarding/tutorial_step_03.png';
import "./authAside.scss"

const T_PREFIX: string = 'pages.authAside.otpCode.';

const AsideByOtpRequest: React.FC = () => {
  const { t } = useTranslation();

    return (
        <div className="platform-section" style={{ maxWidth: `20rem`}}>
            <div className="row">
                <div className='col-md-12 p-0'>
                    <h1 className="platform-title">
                        <span>{t(`${T_PREFIX}wantHelpYou`)}</span> {t(`${T_PREFIX}inThatStep`)}
                    </h1>
                </div>
            </div>
            <div className="row bg-white rounded-2">
                <div className="col-md-6 p-3">
                    <h3 className='fs-6'>{t(`${T_PREFIX}title`)}</h3>
                    <p className='fs-8'>{t(`${T_PREFIX}message`)}</p>        
                </div>
                <div className="col-md-6">
                    <img src={tutorial_step_03}></img>
                </div>
            </div>
        </div>
    );
};

export default (AsideByOtpRequest);